/* global GA_CONFIG, grecaptcha */

import {each} from 'underscore';
import $ from 'jquery';
import {Model, View} from 'backbone';
import {emitChanges, postJSON, slideTo} from 'common';
import {task} from 'loader';
import rivets from 'rivets';
import BookState from 'models/book-state';
import 'bootstrap/timepicker';

export default View.extend({

    events: {
        'click button[data-action=send]': 'bookRent',
        'click button[data-action=pay]': 'bookContract',
        'click button[data-action=login]': 'login'
    },

    initialize() {
        this.apartmentId = this.el.dataset.apartment;

        this.state = new BookState({
            account: 'guest'
        });

        this.state.on('change:account', this.changeAccount, this);

        this.price = new Model({});

        this.state.parseQuery();

        this.errors = new Model({});

        this.sectionAccount = this.el.querySelector('[data-section=account]');
        this.sectionLogin = this.el.querySelector('[data-section=login]');
        this.sectionSignup = this.el.querySelector('[data-section=signup]');
        this.sectionMessage = this.el.querySelector('[data-section=message-text]');
        this.sectionNotes = this.el.querySelector('[data-section=notes]');
        this.sectionPersonal = this.el.querySelector('[data-section=personal]');
        this.sectionStay = this.el.querySelector('[data-section=stay]');
        this.sectionSubmit = this.el.querySelector('[data-section=submit]');

        this.blockEmail = this.sectionPersonal?.querySelector('[data-block=email]');
        this.blockEmail4 = this.sectionMessage?.querySelector('[data-block=email4]');
        this.rowPersonal = this.sectionMessage?.querySelector('[data-row=personal]');

        // Time
        for (const inputTime of this.el.querySelectorAll('[data-input=time]')) {
            const input = inputTime.querySelector('.input__control');
            $(input).timepicker({
                defaultTime: input.dataset.default,
                minuteStep: 5,
                showInputs: false,
                disableFocus: true,
                showMeridian: false
            });
        }

        rivets.bind(this.el, {
            b: this.state,
            p: this.price,
            e: this.errors
        });

        emitChanges(this.el);

        this.state.on('change:currency', async () => {
            const params = new URLSearchParams({
                date: `${this.state.attributes.date.start}~${this.state.attributes.date.end}`,
                currency: this.state.get('currency'),
                guests: this.state.get('guests')
            });

            const res = await fetch(`/apartments/${this.apartmentId}/book/price?${params}`, {
                headers: {
                    'accept': 'application/json'
                }
            });
            if (res.ok) {
                const price = await res.json();
                if (price) {
                    this.price.set(price);
                }
            }
        });
    },

    changeAccount(_m, value) {
        const login = value === 'login';
        const signup = value === 'signup';
        const guest = value === 'guest';

        this.sectionLogin.hidden = !login;
        this.sectionSignup.hidden = !signup;
        this.sectionSubmit.hidden = !(signup || guest);
        if (this.sectionNotes) {
            this.sectionNotes.hidden = !(signup || guest);
        }
        if (this.sectionStay) {
            this.sectionStay.hidden = !(signup || guest);
        }
        if (this.sectionMessage) {
            this.sectionMessage.hidden = !(signup || guest);
            this.blockEmail4.hidden = !guest;
            this.rowPersonal.hidden = !(signup || guest);
        }
        if (this.sectionPersonal) {
            this.sectionPersonal.hidden = !(signup || guest);
            this.blockEmail.hidden = !guest;
        }

        this.errors.clear();
    },

    currency(currency) {
        this.state.set({currency});
    },

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} ev
     */
    async bookRent({currentTarget: btn}) {
        this.errors.clear();

        const data = this.state.toJSON();

        try {
            btn.disabled = true;
            const token = await recaptchaToken({action: 'submit'});
            data.token = token;
            const res = await task(() => postJSON(`/apartments/${this.apartmentId}/book`, data));
            location.href = res.url ?? '/book-thanks';

        } catch (error) {
            if (error.code === 400) {
                const errors = {};
                each(error.details, (value, field) => {
                    errors[field] = value.join('\n');
                });

                this.errors.set(errors);
                slideTo(this.$('.form__control--error:visible')[0]);
            }

        } finally {
            btn.disabled = false;
        }
    },

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} ev
     */
    async bookContract(ev) {
        const btn = ev.currentTarget;
        this.errors.clear();

        const contract = this.el.dataset.contract;

        if (contract) {
            const data = this.state.toJSON();

            try {
                btn.disabled = true;
                const res = await task(() => postJSON(`/contracts/${contract}/book`, data));
                location.href = res.url ?? '/book-thanks';

            } catch (error) {
                if (error.code === 400) {
                    const errors = {};
                    each(error.details, (value, field) => {
                        errors[field] = value.join('\n');
                    });

                    this.errors.set(errors);
                    slideTo(this.$('.form__control--error:visible')[0]);
                }

            } finally {
                btn.disabled = false;
            }

        } else {
            this.bookRent(ev);
        }
    },

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} ev
     */
    async login({currentTarget: btn}) {
        this.errors.clear();

        try {
            btn.disabled = true;
            await GA.login(this.state.get('email'), this.state.get('password'));
            this.state.unset('password');

        } catch (error) {
            this.errors.set({email: error.reason});

        } finally {
            btn.disabled = false;
        }
    },

    async user(user) {
        this.state.set('account', 'guest');
        this.sectionAccount.hidden = user.role === 'user';
        if (user.role === 'user') {
            const profile = await GA.profile();
            this.state.set(profile);
        }
    }
});

function recaptchaToken(options) {
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
            resolve();
        }
        grecaptcha.ready(() => {
            grecaptcha.execute(GA_CONFIG.recaptcha_key, options).then(resolve, reject);
        });
    });
}
